<template>
  <v-card outlined>
    <v-card-title class="py-2">
      <v-icon left>mdi-filter</v-icon>
      Filters
      <v-spacer></v-spacer>
      <v-btn small text color="primary" @click="resetFilters">
        Reset
      </v-btn>
    </v-card-title>
    <v-card-text class="pt-0">
      <v-row>
        <!-- Status Filter -->
        <v-col cols="12" sm="6" md="3">
          <v-select
            v-model="localFilters.statusIds"
            :items="statusOptions"
            label="Status"
            multiple
            dense
            outlined
            clearable
            chips
            small-chips
            deletable-chips
          ></v-select>
        </v-col>

        <!-- Floor Min -->
        <v-col cols="12" sm="6" md="3">
          <v-select
            v-model="localFilters.floorMin"
            :items="floorsOptions"
            label="Floor Min"
            dense
            outlined
            clearable
          ></v-select>
        </v-col>

        <!-- Floor Max -->
        <v-col cols="12" sm="6" md="3">
          <v-select
            v-model="localFilters.floorMax"
            :items="floorsOptions"
            label="Floor Max"
            dense
            outlined
            clearable
          ></v-select>
        </v-col>

        <!-- Rooms Filter -->
        <v-col cols="12" sm="6" md="3">
          <v-select
            v-model="localFilters.rooms"
            :items="roomsOptions"
            label="Rooms"
            multiple
            dense
            outlined
            clearable
            chips
            small-chips
            deletable-chips
          ></v-select>
        </v-col>
      </v-row>

      <!-- Apply Filters Button -->
      <v-row>
        <v-col cols="12" class="text-right">
          <v-btn color="primary" @click="applyFilters" :loading="isLoading">
            Apply Filters
          </v-btn>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import Enums from '../helpers/Enums'

export default {
  name: 'ApartmentFilters',
  props: {
    filters: {
      type: Object,
      required: true
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    floorsOptions: {
      type: Array,
      default: () => []
    },
    roomsOptions: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      localFilters: {
        statusIds: [],
        floorMin: null,
        floorMax: null,
        rooms: []
      }
    }
  },
  computed: {
    statusOptions() {
      const statuses = []
      for (const property in Enums.ApartmentStatus) {
        statuses.push({
          text: this.$t(`apartmentStatuses.${property}`),
          value: Enums.ApartmentStatus[property]
        })
      }
      return statuses
    }
  },
  watch: {
    filters: {
      handler(newFilters) {
        // Only update if the filters are actually different to prevent infinite loop
        if (JSON.stringify(newFilters) !== JSON.stringify(this.localFilters)) {
          this.localFilters = { ...newFilters }
        }
      },
      immediate: true,
      deep: true
    },
    localFilters: {
      handler(newFilters) {
        // Only emit if the filters are actually different to prevent infinite loop
        if (JSON.stringify(newFilters) !== JSON.stringify(this.filters)) {
          this.$emit('update:filters', newFilters)
        }
      },
      deep: true
    }
  },
  methods: {
    applyFilters() {
      this.$emit('apply-filters')
    },
    resetFilters() {
      this.localFilters = {
        statusIds: [],
        floorMin: null,
        floorMax: null,
        rooms: []
      }
      this.$emit('reset-filters')
    }
  }
}
</script>
